import React, { useState } from "react";
import styled from "styled-components"

import { GBMVolatilityOracle } from "../abi/abi";
import { weiFormat } from "../config"

import { IMAGES_FOLDER } from "../config"


async function getOracleValues(
		web3, tokenIn, tokenOut, oracleLookbackInRound, oracleLookbackInSec, GBMVolatilityOracleContractAddress
	) {
	var gbmOracleContract = new web3.eth.Contract(GBMVolatilityOracle, GBMVolatilityOracleContractAddress);
	return gbmOracleContract.methods
		.getParametersEstimation(
			tokenIn,
			tokenOut,
			oracleLookbackInRound,
			oracleLookbackInSec
		).call({  })
		.then(t => {
			const out = {
				"mean": parseFloat(web3.utils.fromWei(t[0].toString(), weiFormat)),
				"variance": parseFloat(web3.utils.fromWei(t[1].toString(), weiFormat)),
			}
			return out
		})
		.catch(err => {
			console.log("error:", err)
			return {
				"mean": 0,
				"variance": 0,
			}
		})
};

const _OracleButton = styled.button`

    color: ${({ theme, isReadyToOracle }) => isReadyToOracle ? theme.oracleButtonTextColor : theme.oracleButtonTextNotReadyColor};
    background-color: ${({ theme, isReadyToOracle }) => isReadyToOracle ? theme.oracleButtonBackgroundColor : theme.oracleButtonBackgroundNotReadyColor};
    opacity: 1;
	border: 1px solid ${({ theme, isReadyToOracle }) => isReadyToOracle ? theme.oracleButtonBackgroundColor : theme.oracleButtonBackgroundNotReadyColor};
	border-radius: 1em;
	cursor: ${({ isReadyToOracle }) => isReadyToOracle ? "pointer" : "default"};
	font-size: 1.5em;
	justify-content: space-between;
	margin-top: 0.5em;
	overflow: hidden;
	padding: 0.8em;
	outline: none;
	font-weight: bold;
	text-decoration: none;
	text-align: center;

	&:hover {
		opacity: ${({ isReadyToOracle }) => isReadyToOracle ? 0.95 : 0.97};
		border: 1px solid ${({ theme }) => theme.oracleButtonBackgroundColor};
	}

	/* Tablets */
	@media (max-width: 1400px) {
		padding: 0.8em;
		font-size: 1.35em;
		margin-top: 0.3em;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		padding: 0.8em;
		font-size: 1.2em;
		margin-top: 0.25em;
	}

`;

function OracleButton(props){
	return (
		<_OracleButton isReadyToOracle={props.isReadyToOracle} onClick={
			props.isReadyToOracle ? () => {
				props.resultReset()
				props.oracleTokenIn.map(oracleTokenIn => {
					props.oracleTokenOut.map(oracleTokenOut => {
						if (oracleTokenIn["oracle"] != oracleTokenOut["oracle"]) {
							getOracleValues(
								props.web3,
								oracleTokenIn["oracle"],
								oracleTokenOut["oracle"],
								props.oracleLookbackInRound,
								props.oracleLookbackInSec,
								props.contractAddress
							)
							.then(r => {
								props.resultHandler(r, oracleTokenIn, oracleTokenOut)
							})
						}
					})
				})
			}
			: () => undefined
		} >
			{props.message}
		</_OracleButton>
	)
}

export default OracleButton;
